import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import NetherlandMofaMain from "./NetherlandMofaMain";
const NetherlandMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <NetherlandMofaMain />
    </div>
  );
};

export default NetherlandMofa;
